import React from 'react';
import PropTypes from 'prop-types';
import { StyledToggleIconWrapper, StyledArrowWrapper, StyledArrow, StyledSeparator } from './styled'

const ToggleIcon = ({ menuOpen }) => (
  <StyledToggleIconWrapper>
    <StyledSeparator />
    <StyledArrowWrapper aria-hidden='true'>
      <StyledArrow menuOpen={menuOpen} />
    </StyledArrowWrapper>
  </StyledToggleIconWrapper>   
);

ToggleIcon.propTypes = {
  menuOpen: PropTypes.bool,
};

export default ToggleIcon;
